let $apifilterControlShow = $('.apifilter .apifilter-control .apifilter-control--show');
let $apifilterControlHide = $('.apifilter .apifilter-body .apifilter-control--hide');

$apifilterControlShow.on('click', function (e) {
    e.preventDefault();
    let $apifilter = $(this).closest('.apifilter');
    console.log($apifilter);

    $apifilter.find('.apifilter-body').show();
    $apifilter.find('.apifilter-control').hide();
});

$apifilterControlHide.on('click', function (e) {
    e.preventDefault();
    let $apifilter = $(this).closest('.apifilter');
    console.log($apifilter);

    $apifilter.find('.apifilter-body').hide();
    $apifilter.find('.apifilter-control').show();
});
